"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _APLabelWithText = _interopRequireDefault(require("../../common/APLabelWithText"));
var _dateHelper = require("../../../helpers/dateHelper");
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
require("./ConfirmSingleReportModal.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var confirmSingleReportClasses = (0, _cssClassesHelper.getBEMClasses)('confirm-single-report');
var ConfirmSingleReportForm = function ConfirmSingleReportForm(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)("core"),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: confirmSingleReportClasses()
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: confirmSingleReportClasses('title')
  }, t("Confirm")), /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t("Report Type:"),
    text: props.payload.type,
    customClass: confirmSingleReportClasses()
  }), /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t("Start Date:"),
    text: (0, _dateHelper.formatDate)(props.payload.startDate),
    customClass: confirmSingleReportClasses()
  }), /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t("End Date:"),
    text: (0, _dateHelper.formatDate)(props.payload.endDate),
    customClass: confirmSingleReportClasses()
  }));
};
ConfirmSingleReportForm.propTypes = {
  payload: _propTypes["default"].object
};
ConfirmSingleReportForm.defaultProps = {
  payload: {
    type: '',
    startDate: '',
    endDate: ''
  }
};
var _default = exports["default"] = ConfirmSingleReportForm;